import { render, staticRenderFns } from "./computerAssistant.vue?vue&type=template&id=5697fbb0&scoped=true"
import script from "./computerAssistant.vue?vue&type=script&lang=js"
export * from "./computerAssistant.vue?vue&type=script&lang=js"
import style0 from "./computerAssistant.vue?vue&type=style&index=0&id=5697fbb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5697fbb0",
  null
  
)

export default component.exports